import { registerQuery } from 'data-fetching-client';
import { hubUserAttributesClient } from '../clients/hubUserAttributesClient';
export const singleHubUserSettingQuery = registerQuery({
  fieldName: 'singleHubUserSettingQuery',
  args: ['settingsKey', 'defaultValue'],
  fetcher: args => hubUserAttributesClient.fetch(args.settingsKey, args.defaultValue)
});